import { Typography } from '@material-tailwind/react';

const ListItemInfo = ({ title, text, color, cssContainer }) => {
  return (
    <div
      className={`${cssContainer}  border-l-4 rounded-md border-blue-500 bg-gray-300 dark:bg-blue-gray-700 w-full `}
    >
      <div className="p-2">
        <Typography variant="small" className="font-bold  focus:bg-red-100 uppercase opacity-60">
          {title}
        </Typography>
      </div>
      <div className="p-1 pl-2">
        <Typography variant="lead" className={`font-bold uppercase ${color}  `}>
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default ListItemInfo;
